import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 14 17",
  "content": "<symbol viewBox=\"0 0 14 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\">\n<path d=\"M1.25 16.0674C0.517857 16.0674 0 15.5018 0 14.5896V1.54515C0 0.642069 0.517857 0.0673828 1.25 0.0673828C1.58333 0.0673828 1.88139 0.175495 2.23197 0.372501L12.9107 6.68084C13.6786 7.14606 14 7.4927 14 8.06738C14 8.64207 13.6786 8.99783 12.9107 9.45393L2.36607 15.6843C1.95536 15.9306 1.625 16.0674 1.25 16.0674Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol